import React from 'react';
import 'moment/locale/ru';
import PropTypes from 'prop-types';
import HackItem from './HackItem';

import './style.scss';

const HacksWeek = (props) => {
  const weekStartDay = props.hackathonsByWeek[0].__week_start;
  const weekEndDay = weekStartDay.clone().add("days", 6);
  let weekName;
  if (weekStartDay.month() === weekEndDay.month()) {
    weekName = `${weekStartDay.format('DD')}-${weekEndDay.format('DD MMMM')}`
  } else {
    weekName = `${weekStartDay.format('DD MMMM')}-${weekEndDay.format('DD MMMM')}`
  }
  return (
    <div className="hackatons-week-block">
      <div className="hackathon-block-splitter">
        <span className="span-line"></span>
        <span className="hackathon-block-week">{weekName}</span>
        <span className="span-line"></span>
      </div>
      <div className="hackatons-week-list">
        {props.hackathonsByWeek.map((hackathon) => <HackItem hackathon={hackathon} key={hackathon.id}></HackItem>) }
      </div>
    </div>
    
  );
};

HacksWeek.propTypes = {
  hackathonsByWeek: PropTypes.array.isRequired,
}

const HacksMonth = (props) => {
  return (
    <div className="hackathons-month-block">
      <div className="hackathons-month-header">{props.hackathonsByMonth[0][0].start_date.locale('ru').format('MMMM YYYY')}</div>
      <div className="hackathon-weeks">
        {
          props.hackathonsByMonth.map((hackathonsByWeek) => (
            <HacksWeek hackathonsByWeek={hackathonsByWeek} key={hackathonsByWeek[0].__week_start}></HacksWeek>
          ))
        }
      </div>
    </div>
  )
}

HacksMonth.propTypes = {
  hackathonsByMonth: PropTypes.array.isRequired,
}

function hasSameMonthYearAsPreviousHackathos(previousHackathon, hackathon) { 
  return (previousHackathon.start_date.month() === hackathon.start_date.month()) && (previousHackathon.start_date.year() === hackathon.start_date.year());
}

/**
 * Splitting hackathons by month and week: Month[Week[hackathon]]
 * @param {Array} hackathons - list of all hackathons
 * @param {Array<Array<Hackathons>>} -> {<Month<Week<Hackathom>>}
 */
function splitHackathonsByMonthWeek(hackathons) {
  const hackathonsSplitedByMonthWeek = [];
  // We need all hackathons to be sorted in desc order by start_date
  hackathons.forEach((hackathon, i) => {
    const previousHackathon = hackathons[i - 1];
    if (i === 0 || !hasSameMonthYearAsPreviousHackathos(previousHackathon, hackathon)) {
      hackathonsSplitedByMonthWeek.push([]);
    }
    const currentMonthHackathons = hackathonsSplitedByMonthWeek[hackathonsSplitedByMonthWeek.length - 1];
    if (i === 0 || !previousHackathon.__week_start.isSame(hackathon.__week_start) || !currentMonthHackathons.length) {
      currentMonthHackathons.push([]);
    }
    const currentWeekHackathons = currentMonthHackathons[currentMonthHackathons.length - 1];
    currentWeekHackathons.push(hackathon);
  });
  return hackathonsSplitedByMonthWeek;
}

const HackList = (props) => {
  if (props.dontSplitByWeeks) {
    return (
      <React.Fragment>
        {
          props.hackathons.map((hackathon) => <HackItem hackathon={hackathon} key={hackathon.id}></HackItem>)
        }
      </React.Fragment>
    );
  }
  
  const hackathonsSplitedByMonthWeek = splitHackathonsByMonthWeek(props.hackathons);
  return (
    <React.Fragment>
      {
        hackathonsSplitedByMonthWeek.map((monthHackathons) => <HacksMonth hackathonsByMonth={monthHackathons} key={`${monthHackathons[0][0].start_date.month()}-${monthHackathons[0][0].start_date.year()}`}></HacksMonth>)
      }
    </React.Fragment>
    
  )
}

HackList.defaultProps = {
  canLoadMoreHackathons: true,
}

HackList.propTypes = {
  dontSplitByWeeks: PropTypes.bool,
  hackathons: PropTypes.array.isRequired,
}

export default HackList;



// WEBPACK FOOTER //
// ./src/components/Hackathons/HacksList/index.js